export const ERROR_REQUIRED = 'Campo requerido *';
export const ERROR_EMAIL = 'No es un email válido *';
export const ERROR_MAX_LENGTH = max =>
  `Deben ser ${max} caracteres o menos *`;
export const ERROR_MIN_LENGTH = min =>
  `Deben ser ${min} caracteres o mas *`;
export const ERROR_NUMBER = 'Debe ser un numero *';
export const ERROR_EQUAL_PASS = 'No coincide con la contraseña *';
export const INVALID_FIRSTNAME = 'Nombre inválido *';
export const INVALID_LASTNAME = 'Apellido inválido *';
export const INVALID_CI = 'CI inválida *';
export const INVALID_PHONE = 'Teléfono inválido *';
export const INVALID_NUMBER = 'Campo inválido *';
export const SHORT_PASSWORD = 'Contraseña muy corta (mínimo 8 caracteres) *';
export const ERROR_LESS_DATE = 'Debe ser menor o igual a la fecha actual *';
export const ERROR_MORE_DATE = 'Debe ser mayor a la fecha actual *';
export const STUDENT_PARENTS_PRESENCE = 'Debe asignarle al menos un padre *';



// WEBPACK FOOTER //
// ./src/constants/messages.js